import { fetcher } from '@/lib/queryClient';
import { HomeGame } from '@/types/game';
import { useQuery } from '@tanstack/react-query';
import { GameCarousel } from '@/components/games/game-carousel';

export const RelatedGames = ({ gameId }: { gameId: HomeGame['id'] }) => {
  const { data: allGames = [], isLoading: isLoadingAllGames } = useQuery<HomeGame[]>({
    queryKey: ['/api/games'],
    queryFn: fetcher,
  });

  return (
    <section className="mb-12">
      <GameCarousel
        disableNavigation
        title="А еще у нас есть..."
        games={allGames
          ?.filter((relatedGame) => relatedGame.id !== gameId)
          .sort(() => Math.random() - 0.5)
          .slice(0, 8)}
      />
    </section>
  );
};
